import axiosInstance from '@/shared/api/axios';
import type {
  ApiWarehouseProductItem,
  ApiWarehouseProductPatchBody,
  ApiWarehouseProductPostBody,
  ApiWarehouseProductsListParams,
  ApiWarehouseProductsListResponse,
} from '@/shared/types/api/warehouse';

export const apiWarehouseProductsListGet = async (
  params: ApiWarehouseProductsListParams,
): Promise<ApiWarehouseProductsListResponse> => {
  const { data } = await axiosInstance.get<ApiWarehouseProductsListResponse>('/warehouse/products', {
    params,
  });
  return data;
};

export const apiWarehouseProductGet = async (id: string): Promise<ApiWarehouseProductItem> => {
  const { data } = await axiosInstance.get<ApiWarehouseProductItem>(`/warehouse/products/${id}`);
  return data;
};

export const apiWarehouseProductPost = async (
  body: ApiWarehouseProductPostBody,
): Promise<ApiWarehouseProductItem> => {
  const { data } = await axiosInstance.post<ApiWarehouseProductItem>('/warehouse/products', body);
  return data;
};

export const apiWarehouseProductPatch = async (
  id: string,
  body: ApiWarehouseProductPatchBody,
): Promise<ApiWarehouseProductItem> => {
  const { data } = await axiosInstance.patch<ApiWarehouseProductItem>(
    `/warehouse/products/${id}`,
    body,
  );
  return data;
};

export const apiWarehouseProductDelete = async (id: string): Promise<void> => {
  await axiosInstance.delete(`/warehouse/products/${id}`);
};
